import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const earningListService = (params: Types.EarningListRequest) =>
  RestAPIClient.call<Types.EarningListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const earningListShortService = (params: Types.EarningListRequest) =>
  RestAPIClient.call<Types.EarningListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });

export const earningCreateService = (params: Types.EarningCreateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const earningUpdateService = (params: Types.EarningUpdateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const earningDeleteService = (id: string) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const earningDetailService = (id: string) =>
  RestAPIClient.call<Types.Earning>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
